// @owner ClientPlatform

import React from 'react';
import type {FC} from 'react';
import {StyledAnchor, StyledRow} from '../../signin/commonSigninStyles';
import {brandViolets} from '../theme/brandColors';
import {styled} from 'styled-components';

const StyledFooter = styled(StyledRow)`
  font-size: 12px;
  font-weight: 400;
  color: #656972;
  text-align: center;
  line-height: 16px;
`;

const Anchor = styled(StyledAnchor)`
  font-weight: 500;
  font-size: 12px;
  color: ${brandViolets.shade900};

  &:hover {
    color: ${brandViolets.shade800};
  }

  &:visited {
    color: ${brandViolets.shade800};
  }
`;

export const LegalTermsFooter: FC = () => (
  <StyledFooter>
    By clicking &quot;Continue&quot;, I acknowledge I have read and agreed to FrontApp, Inc.&apos;s&nbsp;
    <Anchor
      href="https://front.com/legal/saas-services-agreement"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="General Terms (opens in new tab)"
    >
      General Terms
    </Anchor>
    ,&nbsp;
    <Anchor
      href="https://front.com/legal/supplemental-terms#ai_features_terms"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="AI Supplemental Terms (opens in new tab)"
    >
      AI Supplemental Terms
    </Anchor>
    , and&nbsp;
    <Anchor
      href="https://front.com/legal/privacy-notice"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Privacy Notice (opens in new tab)"
    >
      Privacy Notice
    </Anchor>
    .
  </StyledFooter>
);
